// extracted by mini-css-extract-plugin
export default {"container":"DFYH6f","label":"fjddQ3","tooltipContainer":"kSCytC","nameContainer":"tK6SvB","nameButton":"uKK1_E","name":"wUNqYm","tooltip":"jetHxI","loader":"nH39OQ"};